/** @format */

import moment from "moment";

export const getTimeAfter = (
  mCount: number,
  unit?: moment.unitOfTime.DurationConstructor,
) => moment().add(mCount, unit);

export const formatTimeAgo = (timestamp) => {
  if (!timestamp) return '';

  const now = moment();
  const time = moment(timestamp, moment.ISO_8601);

  const diffMinutes = now.diff(time, 'minutes');
  const diffHours = now.diff(time, 'hours');
  const diffDays = now.diff(time, 'days');

  if (diffDays > 0) {
    return `${diffDays} ngày trước`;
  } else if (diffHours > 0) {
    return `${diffHours} giờ trước`;
  } else if (diffMinutes > 0) {
    return `${diffMinutes} phút trước`;
  } else {
    return 'Vừa xong';
  }
};
